export default __webpack_public_path__ + "static/g3-light-logo-6357cb4455d37dcafeaa5678b03e9ef8.svg";